import { useSearchParams } from 'react-router-dom';

export const useFormWatchMode = (readOnly = false) => {
    const [searchParams] = useSearchParams();
    const watchMode = searchParams.get('mode') === 'watch';

    const getFieldMandatory = (required: boolean) => (searchParams.get('mode') === 'watch' || readOnly ? false : required);

    return {
        getFieldMandatory,
        readOnly,
        selectOpen: searchParams.get('mode') !== 'watch' && !readOnly ? undefined : false,
        watchMode,
    };
};
